import { createMutationHook, collapseParams } from '../client';
import { registerV2, registerForgotV2 } from '../services/UserAccountsPublicV2Service';

export const useUserAccountsPublicV2RegisterV2 = createMutationHook(
  collapseParams(collapseParams(registerV2, 'requestBody', 'data'), 'data', 'emailAddress', 'password', 'surname'),
  {
    injectables: ['label', 'customerId', 'businessUnit'],
    flattenData: false,
    flattenBodyPairs: [
      { target: 'requestBody', props: ['data'] },
      { target: 'data', props: ['emailAddress', 'password', 'surname'] },
    ],
  },
);

export const useUserAccountsPublicV2RegisterForgotV2 = createMutationHook(
  collapseParams(
    collapseParams(registerForgotV2, 'requestBody', 'data'),
    'data',
    'emailAddress',
    'password',
    'surname',
  ),
  {
    injectables: ['label', 'customerId', 'businessUnit'],
    flattenData: false,
    flattenBodyPairs: [
      { target: 'requestBody', props: ['data'] },
      { target: 'data', props: ['emailAddress', 'password', 'surname'] },
    ],
  },
);
